/* ============================================================
   TUFTING BAE — Mis Cursos
   Archivo: assets/tufting-chill-cursos.js
   ============================================================ */

(function () {
  'use strict';

  var customerTags = window.LMS_CUSTOMER_TAGS || [];

  function hasAccess(course) {
    if (!course.access_tag) return false;
    return customerTags.indexOf(course.access_tag) !== -1;
  }

  function getProgress(courseId) {
    try {
      var key = 'tc_lms_progress_' + courseId;
      var data = JSON.parse(localStorage.getItem(key) || '[]');
      return Array.isArray(data) ? data.length : 0;
    } catch (e) { return 0; }
  }

  function getTotalLessons(course) {
    if (!course.modules) return 0;
    return course.modules.reduce(function (acc, m) {
      return acc + (m.lesson_count || 0);
    }, 0);
  }

  function renderCourses(courses) {
    var grid = document.getElementById('mc-grid');
    var empty = document.getElementById('mc-empty');
    if (!grid) return;

    var accessible = courses.filter(hasAccess);

    if (!accessible.length) {
      grid.style.display = 'none';
      if (empty) empty.style.display = 'flex';
      return;
    }

    grid.innerHTML = '';

    accessible.forEach(function (course) {
      var total    = getTotalLessons(course);
      var done     = getProgress(course.id);
      var pct      = total > 0 ? Math.round((done / total) * 100) : 0;
      var statusTxt = pct === 100 ? 'Completado' : (pct > 0 ? 'En progreso' : 'Nuevo');
      var statusCls = pct === 100 ? 'mc-badge--done' : (pct > 0 ? 'mc-badge--progress' : 'mc-badge--new');

      var card = document.createElement('a');
      var safeUrl = /^https?:\/\/|^\//.test(course.url) ? course.url : '#';
      card.href = safeUrl;
      card.className = 'mc-card';

      var safeImg = /^https?:\/\//.test(course.image) ? course.image : '';
      var thumb = safeImg
        ? '<img src="' + safeImg + '" alt="' + escHtml(course.title) + '" class="mc-card__img">'
        : '<div class="mc-card__img mc-card__img--placeholder"><span>✦</span></div>';

      card.innerHTML =
        '<div class="mc-card__thumb">' + thumb +
          '<span class="mc-badge ' + statusCls + '">' + statusTxt + '</span>' +
        '</div>' +
        '<div class="mc-card__body">' +
          '<div class="mc-card__tag">' + escHtml(course.tag || 'Curso') + '</div>' +
          '<h3 class="mc-card__title">' + escHtml(course.title) + '</h3>' +
          (course.desc ? '<p class="mc-card__desc">' + escHtml(course.desc) + '</p>' : '') +
          '<div class="mc-card__footer">' +
            '<div class="mc-prog">' +
              '<div class="mc-prog__bar"><div class="mc-prog__fill" style="width:' + pct + '%"></div></div>' +
              '<span class="mc-prog__pct">' + pct + '%</span>' +
            '</div>' +
            '<span class="mc-card__cta">Ir al curso →</span>' +
          '</div>' +
        '</div>';

      grid.appendChild(card);
    });
  }

  function escHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function init() {
    var el = document.getElementById('courses-data');
    if (!el) return;
    var courses = [];
    try { courses = JSON.parse(el.textContent) || []; } catch (e) {}
    if (!Array.isArray(courses)) courses = [];
    renderCourses(courses);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();